import React, {useEffect, useState, useMemo} from 'react';
import {useNavigate} from 'react-router';
import {Container, Stack, Typography} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {useQueryParam} from '../../util/react_hooks.js';
import api from '../../util/api.js';
import {getEnv} from '../../util.js';
import {LoaderComp} from '../../components/Loader.js';
import withMainContainer from '../../components/WithMainContainer.js';
import SCButton from '../../components/SCButton.js';
import config from '../../config.js';

const PaymentCheckComp = props=>{
    let {data, email, loading} = props;
    let navigate = useNavigate();
    let [ipn] = useQueryParam('ipn');
    let envName = useMemo(()=>getEnv());
    if (data?.status=='expired')
    {
        return <>
          <ErrorOutlineIcon color="error" sx={{fontSize: 100}}/>
          <Typography variant="h3" textAlign="center">
            פג תוקף הקישור
          </Typography>
        </>;
    }
    if (data?.payment?.status=='COMPLETE')
    {
        return <>
          <TaskAltIcon color="success" sx={{fontSize: 100}}/>
          <Typography variant="h3" textAlign="center">
            תודה על הרכישה
          </Typography>
          <Stack direction="row" flexWrap="wrap" gap={2}
            justifyContent="center" alignItems="center">
            {data.payment.docUrl&&<SCButton variant="outlined" text="הורדת קבלה"
              icon={<DownloadIcon/>}
              onClick={()=>window.open(data.payment.docUrl)}/>}
            <SCButton variant="contained" text="המשך לאפליקציית המסרים"
              icon={<ChevronLeftIcon/>}
              onClick={()=>navigate(`/tarotmail/simona?tmaEmail=${email}&tmaName=${data.customerName}`)}/>
          </Stack>
        </>;
    }
    if (data?.payment?.status=='PENDING')
    {
        return <>
          <LoaderComp/>
          <Typography textAlign="center">
            התשלום מתבצע, זה יקח רק כמה רגעים...
          </Typography>
          {envName=='DEV'&&<SCButton text="Test IPN"
            onClick={()=>api.tarotmail.ext.testAddRoundIpn({external_data: ipn})}/>}
        </>;
    }
    if (loading)
        return <LoaderComp/>;
};

const TarotmailSimonaAddRoundConfirm = ()=>{
    let [data, setData] = useState();
    let [loading, setLoading] = useState();
    let [paymentId] = useQueryParam('paymentId');
    let [paymentToken] = useQueryParam('paymentToken');
    let [email] = useQueryParam('email');
    useEffect(()=>{
        if (!paymentId||!paymentToken)
            return;
        setLoading(true);
        let es, itvl;
        let connect = ()=>{
            es = new EventSource(
                `${config.API_BASE}tarotmail/simona_add_round/payment/${paymentId}/events?paymentToken=${paymentToken}`);
            es.onerror = e=>{
                console.error('EventSource error', e);
                itvl = setTimeout(()=>connect(), 3000);
            };
            es.addEventListener('waiting', ()=>setData({payment: {status: 'PENDING'}}));
            es.addEventListener('purchase_complete', ev=>{
                setData(JSON.parse(ev.data));
                setLoading(false);
                es.close();
            });
        };
        connect();
        return ()=>{
            clearTimeout(itvl);
            setLoading(false);
            es.close();
        };
    }, [paymentId, paymentToken]);
    return <Container maxWidth="lg">
      <Stack direction="column" alignItems="center" gap={2}
        marginBottom={8} marginTop={5}>
        <PaymentCheckComp data={data} email={email} loading={loading}/>
      </Stack>
    </Container>;
};

export default withMainContainer(TarotmailSimonaAddRoundConfirm);
